module.exports = __webpack_public_path__ + "img/logo_combined.22fedf20.png";